import script from "./ReserveUnit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReserveUnit.vue?vue&type=script&setup=true&lang=ts"

import "./ReserveUnit.vue?vue&type=style&index=0&id=4274de2b&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4274de2b"]])

export default __exports__